import { combineReducers } from "@reduxjs/toolkit";
import { adminReducer } from "./adminSlice.js";
import { authActions, authReducer, logoutCmtsSession, refreshCmtsToken } from "./authSlice.js";
import { complaintReducer } from "./complaintSlice.js";
import { dashboardReducer } from "./dashboardSlice.js";
import { masterDataReducer } from "./masterDataSlice.js";
import { permissionReducer } from "./permissionSlice.js";
import { pwaReducer } from "./pwaSlice.js";
import { reportReducer } from "./reportSlice.js";
import { tenantReducer } from "./tenantSlice.js";
import { uiReducer } from "./uiSlice.js";

const appReducer = combineReducers({
  auth: authReducer,
  tenant: tenantReducer,
  permission: permissionReducer,
  ui: uiReducer,
  masterData: masterDataReducer,
  complaint: complaintReducer,
  admin: adminReducer,
  dashboard: dashboardReducer,
  report: reportReducer,
  pwa: pwaReducer,
});

export type CmtsRootReducerState = ReturnType<typeof appReducer>;

export const rootReducer = (state: CmtsRootReducerState | undefined, action: Parameters<typeof appReducer>[1]): CmtsRootReducerState => {
  const shouldClearSensitiveState = authActions.logoutSucceeded.match(action) || logoutCmtsSession.fulfilled.match(action) || refreshCmtsToken.rejected.match(action);

  if (!shouldClearSensitiveState) {
    return appReducer(state, action);
  }

  const preservedPwa = state?.pwa;
  const nextState = appReducer(undefined, action);
  return {
    ...nextState,
    pwa: preservedPwa ?? nextState.pwa,
  };
};
